import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';

const CustomerContactInfoFloor = props =>
  (
<CustomerContactInfoComp
  {...props}
  errorMessages={{
    'field_is_invalid': 'Your floor is invalid',
  }}
  label="Floor"
  name="floor"
/>
  );

export default CustomerContactInfoFloor;
